<script>
export default {
  name: 'stateless-factory',
  functional: true,
  props: {
    componentProp: {
      required: true
    },
    dataProp: {
      required: true
    }
  },
  render (createElement, context) {
    return createElement(
      context.props.componentProp,
      context.props.dataProp
    )
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/StatelessFactory.vue